import Story from '../sections/Story';
import Metrics from '../sections/Metrics';
import Statement from '../sections/Statement';
import Reviews from '../sections/Reviews';
import { Seo, breadcrumbJsonLd } from '../lib/seo';

export default function About() {
  return (
    <>
      <Seo
        title="About Revive Builders LLC — Central Texas General Contractor Since 2021"
        description="Founded in 2021 on twenty years in the trade, Revive Builders is a licensed and insured general contractor serving multi-family and commercial properties across San Antonio and Austin, TX."
        path="/about"
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'About', path: '/about' },
          ]),
        ]}
      />
      <div className="pt-20">
        <Story />
        <Statement />
        <Metrics />
        <Reviews />
      </div>
    </>
  );
}
